import VideosHouse from "./VideosHouse";
import Filter from "../../../Utils/Filter";
import SpotifyIcon from "../../SpotifyIcon";
import "@justinribeiro/lite-youtube";
import Buscador from "../../Buscador.jsx";

function DeepHouse() {
  return (
    <div className="flex items-center flex-col pb-24">
      <div className="flex min-h-full w-max text-center xl:ml-10 top-0 hover:bg-black hover:bg-opacity-50">
        <span className="uppercase descrip font-bold text-[#f0ffff] hover:text-red-500 cursor-default">
          House & Deep House
        </span>
      </div>
      <Buscador filter={Filter} />
      <div id="container" className="h-full w-full flex flex-wrap gap-12 px-6 ">
        {VideosHouse.map((item) => (
          <article className="border-b-2 rounded-b-3xl mx-auto h-auto w-full sm:w-96">
            <div key={item.id} className="grid items-center ">
              <lite-youtube
                videoid={item.video_id}
                posterquality="maxresdefault"
              ></lite-youtube>
              <div className="text-[#f0ffff] my-2 descrip text-center whitespace-normal">
                <a
                  className="hover:text-red-600 cursor-pointer flex justify-center"
                  href={`https://open.spotify.com/search/` + item.artist}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="mr-1">{item.artist}</span>
                  <SpotifyIcon />
                </a>
                <br />
                <span className="hover:text-gray-300 cursor-default">
                  {item.title}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
      <div className="py-28"></div>
      {/*<Navigator />*/}
    </div>
  );
}

export default DeepHouse;
